import { axiosInstance } from "~/plugins/axios";

export function getDropdownAddOns() {
  return axiosInstance.get("/dropdown/adds-on/vehicle");
}

export function getDropdownAddOnsTour() {
  return axiosInstance.get("/dropdown/adds-on/tour");
}


export function getDropdownTourPackage() {
  return axiosInstance.get("/dropdown/tour-package");
}

export function getDropdownCountries() {
  return axiosInstance.get(`/dropdown/country`);
}

export function getDropdownHearAboutUs() {
  return axiosInstance.get(`/dropdown/hear-about-us`);
}

export function getDropdownVehicleType() {
  return axiosInstance.get(`/dropdown/vehicle-type`);
}
